import React from 'react';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import LocalGasStationIcon from '@material-ui/icons/LocalGasStation';
import AccountBalanceIcon from '@material-ui/icons/AccountBalance';
import LockIcon from '@material-ui/icons/Lock';
import AssessmentIcon from '@material-ui/icons/Assessment';
import { ReportsMenu, UserManagementIcon } from '../../../components/icons';

export const SideBarData = [
    {
        name: "Account",
        icon: <AccountCircleIcon style={{ fontSize: 26 }} />,
        path: "/profile/account",
        type: 'submenu',
    },
    // {
    //     name: "Diesel Prices",
    //     icon: <LocalGasStationIcon style={{ fontSize: 26 }} />,
    //     submenu: "/profile/account"
    //     type: 'submenu',
    //     path: "/profile/account",
    // },
    // {
    //     name: "Bank Accounts",
    //     icon: <AccountBalanceIcon style={{ fontSize: 26 }} />,
    //     submenu: "/profile/account"
    //     type: 'submenu',
    //     path: "/profile/account",
    // },
    // {
    //     name: "Security & Backup",
    //     icon: <LockIcon style={{ fontSize: 26 }} />,
    //     submenu: "/profile/account"
    //     type: 'submenu',
    //     path: "/profile/account",
    // },
    {
        name: "User Management",
        icon: <UserManagementIcon />,
        path: "/profile/user-management",
        type: 'submenu'
    },
]